import * as React from 'react';
import { useTheme } from 'styled-components';

const TickIcon = (props: React.SVGProps<SVGSVGElement>) => {
    const theme = useTheme();

    return (
        <svg
            width="20"
            height="14"
            viewBox="0 0 20 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-disabled
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 6.56195L7.07107 13.633L20 0.706465L19.2925 0L7.07107 12.2186L0.710961 5.85682L0 6.56195Z"
                fill={theme.colors.charcoal100}
            />
        </svg>
    );
};

export default TickIcon;
